// src/theme/globalStyle.ts
import { createGlobalStyle } from 'styled-components'
import { COLORS, SHADOWS } from './tokens'

export const GlobalStyle = createGlobalStyle`
  :root {
    --color-primary: ${COLORS.primary};
    --color-bg: ${COLORS.background};
    --color-border-primary: ${COLORS.borderPrimary};
    --color-disabled: ${COLORS.disabled};
    --color-text-primary: ${COLORS.textPrimary};
    --color-text-secondary: ${COLORS.textSecondary};
    --shadow-box: ${SHADOWS.boxShadow};
  }

  body {
    background: var(--color-bg);
    color: var(--color-text-primary);
    font-family: 'WixMadeforDisplay', sans-serif;
    margin: 0;
    padding: 0;
  }
`
